import { render, staticRenderFns } from "./LocalizationButton.vue?vue&type=template&id=875190b8"
import script from "./LocalizationButton.vue?vue&type=script&setup=true&lang=js"
export * from "./LocalizationButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports